/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JourneyType,
    JourneyTypeFromJSON,
    JourneyTypeFromJSONTyped,
    JourneyTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface JourneyTypeFilterItemOutput
 */
export interface JourneyTypeFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof JourneyTypeFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {JourneyType}
     * @memberof JourneyTypeFilterItemOutput
     */
    value?: JourneyType;
    /**
     * 
     * @type {boolean}
     * @memberof JourneyTypeFilterItemOutput
     */
    isEffective?: boolean;
}

export function JourneyTypeFilterItemOutputFromJSON(json: any): JourneyTypeFilterItemOutput {
    return JourneyTypeFilterItemOutputFromJSONTyped(json, false);
}

export function JourneyTypeFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyTypeFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : JourneyTypeFromJSON(json['value']),
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function JourneyTypeFilterItemOutputToJSON(value?: JourneyTypeFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': JourneyTypeToJSON(value.value),
        'isEffective': value.isEffective,
    };
}


